import NullInput from '@/components/CustomInputs/KeyValueTypeInputs/NullInput'
import JsonParsingInput from '@/components/CustomInputs/KeyValueTypeInputs/JsonParsingInput'
import BooleanInput from '@/components/CustomInputs/KeyValueTypeInputs/BooleanInput'
import NumberInput from '@/components/CustomInputs/KeyValueTypeInputs/NumberInput'
import StringInput from '@/components/CustomInputs/KeyValueTypeInputs/StringInput'
import ObjectInput from '@/components/CustomInputs/KeyValueTypeInputs/ObjectInput'
import ArrayInput from '@/components/CustomInputs/KeyValueTypeInputs/ArrayInput'
import DateInput from '@/components/CustomInputs/KeyValueTypeInputs/DateInput'

export default {
  NullInput,
  JsonParsingInput,
  BooleanInput,
  NumberInput,
  StringInput,
  ObjectInput,
  ArrayInput,
  DateInput
}
